import React, { useState } from 'react';
import firebase from '../hooks/firebase';
import styled from 'styled-components';
import color, { RegulationActionColor } from '../styles/color';
import firebaseApp from '@firebase/app';
import Loader from 'react-spinners/ClipLoader';
import { Spring } from 'react-spring/renderprops';

const ChoiceList = styled.ul`
  list-style: none;

  display: flex;
  flex-flow: row wrap;
  width: 100%;
`;

const ChoiceContainer = styled.li`
  flex: 0 0 100%;
  padding: 20px;
`;

const Bar = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: ${({ action }) => ACTION_TO_COLOR[action]};
  z-index: -1;

  width: ${({ voted, percentage }) => (voted ? `${percentage}%` : 0)};
`;

const Choice = styled.div`
  border: 1px dotted ${({ action }) => ACTION_TO_COLOR[action]};
  padding: 20px 40px;
  max-width: 500px;
  margin: 0 auto;
  cursor: ${({ voted }) => (voted ? 'default' : 'pointer')};
  position: relative;

  text-align: center;

  & > div {
    margin-bottom: 20px;
  }
  & div span {
    background-color: ${({ action }) => ACTION_TO_COLOR[action]};
    padding: 1px 4px;
    color: white;
  }

  &:hover {
    background-color: ${({ action, voted }) =>
      !voted && ACTION_TO_COLOR[action]};
  }
`;

const ACTION = [
  'การแบนถุงพลาสติกอย่างเด็ดขาดและบางส่วน (Total or partial ban)',
  'การจัดเก็บค่าธรรมเนียม ค่าปรับ และ/หรือภาษีถุงพลาสติก(Economic instruments)',
  'การห้ามใช้และเก็บเงิน (Combination)',
  'ความร่วมมือระหว่างรัฐและเอกชน (Private public agreement)',
];

const ACTION_TO_COLOR = {
  'การแบนถุงพลาสติกอย่างเด็ดขาดและบางส่วน (Total or partial ban)': RegulationActionColor(
    'การห้ามผลิต แจก ใช้ และ/หรือ ซื้อขายอย่างเด็ดขาดหรือบางส่วน'
  ),
  'การจัดเก็บค่าธรรมเนียม ค่าปรับ และ/หรือภาษีถุงพลาสติก(Economic instruments)': RegulationActionColor(
    'เครื่องมือทางเศรษฐศาสตร์'
  ),
  'การห้ามใช้และเก็บเงิน (Combination)': RegulationActionColor(
    'การผสมกันระหว่างเครื่องมือทางเศรษฐศาสตร์และการห้าม'
  ),
  'ความร่วมมือระหว่างรัฐและเอกชน (Private public agreement)': RegulationActionColor(
    'ข้อตกลงระหว่างภาครัฐและภาคเอกชน'
  ),
};

const Question = styled.h3`
  text-align: center;
  color: ${color.ippdDarker};
  font-size: 25px;
  margin: 10px 20px;
`;

let options = [];
const Vote = () => {
  const { db } = firebase;
  const [voted, setVoted] = useState(false);
  const [sendingVote, setSendingVote] = useState(false);

  async function vote(title) {
    setSendingVote(true);

    // get latest data
    const docRef = db.collection('plastic').doc('result');

    await docRef.update({
      [title]: firebaseApp.firestore.FieldValue.increment(1),
    });

    const doc = await docRef.get();
    options = doc.data();

    setSendingVote(false);
    setVoted(true);
  }

  function percentage(action) {
    const total = Object.entries(options).reduce(
      (prev, cur) => (prev = prev + cur[1]),
      0
    );

    return (options[action] * 100) / total;
  }

  return (
    <section style={{ margin: '50px 0' }}>
      <Question>
        แล้วในความคิดของคุณ การจัดการถุงพลาสติกหูหิ้วของประเทศไทยควรเป็นอย่างไร
        ?
      </Question>
      <ChoiceList>
        {ACTION.map((action, i) => (
          <ChoiceContainer key={action}>
            <Choice
              action={action}
              voted={voted}
              onClick={() => !voted && vote(action)}
            >
              <Spring
                from={{ width: 0 }}
                to={{ width: voted ? percentage(action) : 0 }}
              >
                {(props) => (
                  <>
                    <div>
                      <span>
                        {voted ? (
                          parseFloat(props.width).toFixed(2) + '%'
                        ) : sendingVote ? (
                          <Loader size={12.5} color="white" />
                        ) : (
                          `วิธีที่ ${i + 1}`
                        )}
                      </span>
                    </div>
                    <Bar
                      action={action}
                      voted={voted}
                      style={{ width: props.width + '%' }}
                    />
                  </>
                )}
              </Spring>
              {action}
            </Choice>
          </ChoiceContainer>
        ))}
      </ChoiceList>
    </section>
  );
};

export default Vote;
